export const NOT_FOUND = '/404'

export const PUBLIC_APPLICATION_OLD = '/application/dossier/:applicationId'
export const NEW_APPLICATION = '/rdv/:id/'
export const APPLICATION = '/application/:applicationId/'
export const APPLICATION_BOOKING = `${APPLICATION}booking`
export const APPLICATION_DOSSIER = `${APPLICATION}files`
export const APPLICATION_DOSSIER_CANCEL = `${APPLICATION}cancel`
export const APPLICATION_DOSSIER_CANCELLED = `${APPLICATION}cancelled`
export const APPLICATION_BOOKING_NEW_RESCHEDULE = `${APPLICATION}new_reschedule`
export const APPLICATION_INTEREST = `${APPLICATION}interest`
